import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getVariantOptions } from '../graphql/quote';
import apolloClient from '../../utils/apollo-client';

export default async function getColoursAndExtras(variantId) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getVariantOptions;
  }
  const response = await apolloClient().then((client) =>
    client.query({
      query: getVariantOptions,
      variables: { variantId }
    })
  );
  return response.data.getVariantOptions;
}
